import React, { useMemo } from 'react';
import ModuleType from '../../../../model/ModuleType';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useLabel from '../../utils/Translations/useLabel';
import MultiselectFilter from './MultiselectFilter';
const ModuleSelector = ({ title, ...props }) => {
    const _title = useLabel('Module', title);
    const { options } = useEnumerableModel(ModuleType);
    const sortedOptions = useMemo(() => [...options].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })), [options]);
    return (<MultiselectFilter itemId={itemIdValue} options={sortedOptions} title={_title} {...props}/>);
};
export default ModuleSelector;
